import * as React from "react";
const SvgShareFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.5 2a3.5 3.5 0 1 1-2.652 5.784l-6.87 3.818a3.5 3.5 0 0 1 0 .797l6.87 3.817a3.5 3.5 0 1 1-.82 1.833l-6.844-3.803a3.5 3.5 0 1 1 0-4.493l6.845-3.802A3.5 3.5 0 0 1 18.5 2", clipRule: "evenodd" }));
export default SvgShareFill;
